import { useCallback } from 'react';
import { useFieldActions } from '../../contexts/field-actions-context';
export const useUploadSignature = () => {
  const {
    actions,
    formId
  } = useFieldActions();
  const uploadFile = actions == null ? void 0 : actions.uploadFile;
  return useCallback(async file => {
    if (!uploadFile) {
      if (!uploadFile) {
        throw new Error('No uploadFile action');
      }
    }
    const fileDescriptor = await uploadFile({
      file,
      formId
    });
    const {
      id,
      displayName,
      url
    } = fileDescriptor;
    return {
      fileId: id,
      displayName: displayName || file.name,
      url: url || '',
      fileType: file.type
    };
  }, [uploadFile, formId]);
};
//# sourceMappingURL=use-upload-signature.js.map